import React from "react";
import { Button } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

function ButtonSection({
  handleSaveNextDefault,
  handleMarkReviewDefault,
  currentQuestion,
  handleClearResponse,
  setOptionId,
  handleBack,
  isLast,
  handleOpenSubmitModal,
  setCurrentQuestionBySubject,
  currentQuestionBySubject,
}) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 20px",
        borderTop: "1px solid black",
      }}
    >
      {/* Left side buttons */}
      <div
        style={{
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        {/* <Button
          size="small"
          color="inherit"
          startIcon={<ArrowBackIosNewIcon fontSize="small" />}
        ></Button> */}
        {currentQuestionBySubject !== 0 && (
          <ArrowBackIosNewIcon
            onClick={() => {
              handleBack();
              setCurrentQuestionBySubject((prev) => prev - 1);
            }}
            style={{ cursor: "pointer" }}
            fontSize="small"
          />
        )}

        <Button
          onClick={async () => {
            if (isLast) {
              handleOpenSubmitModal();
            } else {
            const next =  await handleSaveNextDefault();
              if (!isLast && next) {
                setCurrentQuestionBySubject((prev) => prev + 1);
              }
            }
          }}
          size="small"
          variant="contained"
        >
          {isLast ? "submit" : "Save & Next"}
        </Button>

        <Button
          onClick={() => handleSaveNextDefault(false)}
          size="small"
          variant="outlined"
        >
          Save Response
        </Button>
      </div>

      {/* Right side buttons */}
      <div
        style={{
          display: "flex",
          gap: "20px",
        }}
      >
        <Button
          onClick={() => {
            handleClearResponse();
            setOptionId("");
          }}
          size="small"
          variant="outlined"
          color="inherit"
        >
          Reset
        </Button>
        <Button
          size="small"
          variant="outlined"
          color="inherit"
          onClick={async () => {
           const next = await handleMarkReviewDefault("marked");
            if (!isLast && next) {
              setCurrentQuestionBySubject((prev) => prev + 1);
            }
          }}
        >
          Review
        </Button>
      </div>
    </div>
  );
}

export default ButtonSection;
